<template>
    <modal id="employee-day-shift-modal"
           size="large"
           v-model="showModal"
           :title="$fieldTitle(buttonFirstTitle, 'employee_day_shift', true)"
           @submit="submitData"
           :scrollable="false"
           :loading="loading"
           :preloader="preloader">
        <template #footer>
            <button 
                type="button"
                class="btn btn-secondary mr-2"
                data-dismiss="modal"
                @click="showModal = false">
                {{ $t('cancel') }}
            </button>
            <button 
                v-if="selectedUrl"
                type="button"
                class="btn btn-danger mr-2"
                @click="confirmDelete"
                :disabled="loading">
                {{ $t('delete') }}
            </button>
            <button 
                v-if="selectedUrl"
                type="button"
                class="btn btn-success mr-2"
                @click="confirmShift"
                :disabled="loading || formData.status == 1">
                {{ $t('confirm') }}
            </button>
            <app-submit-button
                :loading="loading"
                :label="$t('save')"
                @click="submitData"
            />
        </template>
        <form
            ref="form"
            @submit.prevent="submitData"
        >
            <app-form-group
                v-if="canUpdateStatus && selectedUrl && formData.full_name"
                :label="$t('employee')"
                type="text"
                v-model="formData.full_name"
                :placeholder="$t('search_and_select_an_employee')"
                disabled
            />
            <app-form-group-selectable
                :label="$t('employee')"
                type="search-select"
                v-if="canUpdateStatus && !selectedUrl"
                v-model="formData.user_id"
                list-value-field="employee_name"
                :placeholder="$t('search_and_select_an_employee')"
                :error-message="$errorMessage(errors, 'user_id')"
                :fetch-url="`${apiUrl.TENANT_SELECTABLE_USER}?with_auth=yes`"
            />

            <app-form-group-selectable
                :label="$t('day_shift')"
                type="search-select"
                v-if="canUpdateStatus"
                v-model="formData.day_shift_id"
                list-value-field="name"
                :placeholder="$t('search_and_select_a_day_shift')"
                :error-message="$errorMessage(errors, 'day_shift_id')"
                :fetch-url="`${apiUrl.DAY_SHIFT}?get-all=1`"
            />

            <app-form-group
                :label="$t('date')"
                type="date"
                v-model="formData.date"
                :required="true"
                :placeholder="$placeholder('date', '')"
                :error-message="$errorMessage(errors, 'date')"
                disabled
            />

            <app-form-group
                :label="$t('short_description')"
                type="textarea"
                form-group-class="mb-0"
                :text-area-rows="4"
                v-model="formData.description"
                list-value-field="pivot.description"
                :placeholder="$placeholder('description_here')"
                :error-message="$errorMessage(errors, 'description')"
            />
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {
    formatDateTimeForServer,
    formatDateForServer,
    formatUtcToLocal
} from "../../../../../common/Helper/Support/DateTimeHelper";
import { axiosDelete, axiosPost } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "EmployeeDayShiftCreateEditModal",
    mixins: [ModalMixin, FormHelperMixins],
    props: {
        tableId: {},
        employee: {},
        specificId: {},
        selectedColumn: {},
        selectedUrl: null,
    },
    data() {
        return {
            formData: {},
        }
    },
    mounted() {
        this.$nextTick(()=>{
            if (window.innerHeight < 700){
                document.getElementsByClassName('modal-body')[0].style.height = '560px'
            }
        })
    },
    methods: {
        submitData() {
            this.loading = true;
            const formData = {...this.formData};
            formData.date = formatDateForServer(this.formData.date);

            let requestUrl = `${this.apiUrl.EMPLOYEE_DAY_SHIFT}/update`;
            if (!this.selectedUrl) {
                requestUrl = `${this.apiUrl.EMPLOYEE_DAY_SHIFT}/create`;
            }
            this.submitFromFixin('post', requestUrl, formData);
        },
        afterSuccess({data}) {
            this.loading = false;
            $('#employee-day-shift-modal').modal('hide');
            this.$toastr.s('', data.message);
            if (this.tableId) {
                this.$hub.$emit(`reload-${this.tableId}`);
            } else {
                this.$emit('updateSuccess')
            }
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.formData = response.data;
            this.formData.user_id = this.formData.pivot?.user_id || this.formData.user_id;
            this.formData.day_shift_id = this.formData.pivot?.day_shift_id || this.formData.day_shift_id;
            this.formData.date = this.formData.pivot?.date || this.formData.date;
            this.formData.description = this.formData.pivot?.description || this.formData.description;
            // Keep full_name from response for employee display
            if (response.data.full_name) {
                this.formData.full_name = response.data.full_name;
            }
        },
        confirmDelete() {
            this.loading = true;
            const id = this.formData.id;
            
            return axiosDelete(`${this.apiUrl.EMPLOYEE_DAY_SHIFT}?id=${id}`).then(response => {
                this.$toastr.s('', response.data.message);
                $('#employee-day-shift-modal').modal('hide');
                this.loading = false;
                
                if (this.tableId) {
                    this.$hub.$emit(`reload-${this.tableId}`);
                } else {
                    this.$emit('updateSuccess')
                }
            }).catch((error) => {
                this.loading = false;
                if (error.message) {
                    this.toastException(error);
                }
            });
        },
        confirmShift() {
            this.loading = true;
            let formData = JSON.parse(JSON.stringify(this.formData));
            formData.status = 1;
            let requestUrl = `${this.apiUrl.EMPLOYEE_DAY_SHIFT}/update`;
            
            axiosPost(requestUrl, formData).then(response => {
                this.loading = false;
                $('#employee-day-shift-modal').modal('hide');
                this.$toastr.s('', response.data.message);
                if (this.tableId) {
                    this.$hub.$emit(`reload-${this.tableId}`);
                } else {
                    this.$emit('updateSuccess')
                }
            }).catch((error) => {
                this.loading = false;
                if (error.message) {
                    this.$toastr.e('', error.response.data.message || this.$t('something_went_wrong'));
                }
            });
        },
    },
    created() {
        if (!this.employee && !this.canUpdateStatus && !this.specificId) {
            this.formData.user_id = window.user.id
        }

        if (this.specificId) {
            this.formData.user_id = this.specificId
        }

        if (this.selectedColumn) {
            this.formData.user_id = this.selectedColumn.user_id;
            this.formData.date = this.selectedColumn.date;
        }
    },
    computed: {
        canUpdateStatus() {
            if (this.specificId && this.$can('update_attendance_status')) {
                return false;
            }
            if (this.employee && this.$can('update_attendance_status')) {
                this.formData.user_id = this.employee.id;
                return false;
            }
            return this.$can('update_attendance_status');
        },
        user_id() {
            return window.user.id;
        },
        buttonFirstTitle() {
            return this.$can('update_attendance_status') ? 'edit' : 'request';
        }
    }
}
</script>
